module.exports = __webpack_public_path__ + "img/speedometer.0ec9fd1c.png";